import { useMutation } from '@tanstack/react-query';

import { venueUpdatePortfolioContentApi } from '../../../api/venue/venueUpdatePortfolioContentApi';

export const useUpdatePortfolioMutation = () => {
  const updatePortfolioMutation = useMutation({
    mutationFn: venueUpdatePortfolioContentApi,
    onSuccess: async () => {
      console.log('positions updated successfully');
    },
  });
  return updatePortfolioMutation;
};
